<template>
	<div class="action-button-wrapper">
      <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('maintenanceMode')">
          <span class="icon-cont">
              <maintanance-icon class="icon-default maintanance-icon"></maintanance-icon>
          </span>
          <span>maintenance mode</span>
      </b-button>
  </div>
</template>

<script>
import MaintananceIcon from '../../assets/maintanance.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	MaintananceIcon
  },
  data() {
    return {
      serverURL: window.serverURL,
    };
  },
  methods:{
    emitAction(action) {
      this.$emit('action', { action: action, site: this.site });
    },
  }
};
</script>